module.exports = __webpack_public_path__ + "static/media/station.85642ae7.svg";